// extracted by mini-css-extract-plugin
export default {"empty":"MyRequests_empty__B4ASX","title":"MyRequests_title__MoBHV","subtitle":"MyRequests_subtitle__wdfEJ"};